import React from "react";
import courseDetails from "../../images/courses-details.jpg";
import circle from "../../images/circle-shape.png";
import author from "../../images/author-03.jpg";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape14 from "../../images/shape-14.png";
import logo from "../../images/logo.png";
import { useSpring, animated } from "react-spring";

import { useParams } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import {
  Player,
  ControlBar,
  ForwardControl,
  ReplayControl,
  BigPlayButton,
  PlaybackRateMenuButton,
} from "video-react";
import "video-react/dist/video-react.css";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./CourseList.css";
import useCallbackPrompt from "./useCallbackPrompt";
import DialogBox from "./DialogBox";
import { useLocation } from "react-router-dom";
// import { fadeIn } from 'react-animations'
// import { bounce } from 'react-animations';
// import Radium, {StyleRoot} from 'radium';

// import { Prompt } from 'react-router';
import "./Prompt";
// import SearchBar from './SearchBar';s
import SearchBar from "./SearchBar";

// import courseDetails from '../../images/courses-details.jpg';
const CourseList = () => {

 

  const handleDoubleClick = (event) => {
    event.preventDefault();
    // Custom logic to handle the double-click event
  };

  const handleFullscreenButtonClick = (event) => {
    event.preventDefault();

    // Prevent fullscreen action
  };
  // const styles = {
  //   bounce: {
  //     animation: 'x 1s',
  //     animationName: Radium.keyframes(bounce, 'bounce'),
  //   },
  // };
  const verena = sessionStorage.getItem("user_email");
  console.log(verena);
  const [text, setText] = useState(verena);
  const springProps = useSpring({
    to: async (next) => {
      while (true) {
        await next({
          position: "relative",
          zIndex: "9999999999",
          transform: `translate(${Math.random() * 640 - 50}px, ${
            Math.random() * 500 - 20
          }px)`,
        });
      }
    },
    config: {
      tension: 20,
      friction: 10,
    },
  });

  const [message, setMessage] = useState("");
  // document.documentElement.requestFullscreen()

  const playerRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const beforeUnLoad = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.returnValue = "";
  };

  // const handleKeyDown = event => {
  //   console.log('User pressed: ', event.key);
  // };
  document.onkeyup = key1;
  const [mystream, setmystream] = useState(null);
  const [videoswitch, setvideo] = useState(true);
  const [audioswitch, setaudio] = useState(true);
  const myvideo = useRef(null);
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        myvideo.current.srcObject = stream;
        myvideo.current.autoplay = true;
        myvideo.current.muted = false;
        setmystream(stream);
      });
  }, []);

  function key1(e) {
    if (
      e.code === "Space" ||
      e.code === "ArrowLeft" ||
      e.code === "ArrowRight"
    ) {
      return (videoPlayerContainer.style.display = "flex");
    }
    const videoPlayerContainer = document.querySelector(
      "#video-player-container"
    );
    if (videoPlayerContainer) {
      videoPlayerContainer.style.display = "none";
    }
    console.log(e);
    switch (e.which) {
      case 49: // 1
        break;
      case 44: // PrintScreen
        console.log("You pressed print screen");
        break;
      case 91: // left windows
      case 92: // right windows
        console.log("You pressed the one of the windows keys");
        break;
    }
  }

  const ref = useRef(null);

  useEffect(() => {
    ref.current.focus();
  }, []);

  useEffect(() => {
    console.log("unload");
    window.addEventListener("beforeunload", beforeUnLoad);

    return () => {
      console.log("unload");
      window.removeEventListener("beforeunload", beforeUnLoad);
    };
  }, []);

  let { real_id } = useParams();
  const [progress, setProgress] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [allLessons, setAllLessons] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [keyword, setKeyword] = useState("");
  const [notes, setNotes] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const onButtonClickHandler = () => {
    console.log("here");
    setShowMessage(true);
  };
  // const [lessonSub, setlessonSub] = useState([]);
  // function handleSearch(e) {
  //   e.preventDefault();
  //   props.onSearch(searchTerm);
  // }
  // const remove = (index) => {
  //   setNotes((notes) => notes.filter((_, i) => i !== index));
  // };
  // const filteredNotes = useMemo(() => {
  //   if (!keyword) {
  //     return notes;
  //   }
  //   return notes.filter(({ title, description }) => {
  //     return title.includes(keyword) || description.includes(keyword);
  //   });
  // }, [keyword, notes]);
  const navigate = useNavigate();
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  function Nav(s) {
    navigate("/courseList/" + s);
  }
  let { id } = useParams();

  const [showLessons, setshowLessons] = useState([]);
  async function getshowLessons() {
    let { data } = await axios.get(
      `https://maps-medics-be.onrender.com/show_lession/${real_id}` +
        "/" +
        sessionStorage.getItem("user_id")
    );
    setshowLessons(data.result);

    console.log(data.result);
  }

  async function getAllLessons() {
    let { data } = await axios.get(
      "https://maps-medics-be.onrender.com/show_lessions/" +
        id +
        "/" +
        sessionStorage.getItem("user_id")
    );
    setAllLessons(data.result);

    console.log(data.result);
  }
  useEffect(() => {
    getshowLessons();
    getAllLessons();
  }, []);

  const handleSeekBackward = (seconds) => {
    const currentTime = playerRef.current.getState().player.currentTime;
    sessionStorage.setItem("progress", currentTime - seconds);
    playerRef.current.seek(currentTime - seconds);
  };

  const handleSeekForward = (seconds) => {
    const currentTime = playerRef.current.getState().player.currentTime;
    sessionStorage.setItem("progress", currentTime + seconds);
    playerRef.current.seek(currentTime + seconds);
  };
  const handleSpeedChange = (speed) => {
    const currentTime = playerRef.current.getState().player.currentTime;
    sessionStorage.setItem("progress", currentTime);
    playerRef.current.setPlaybackRate(speed);
  };
  function EachLesson(o) {
    navigate("/courseList/" + id + "/" + o);
    // getAllLessons()
    getshowLessons();
  }
  function formatDuration(duration) {
    if (duration >= 3600) {
      // Display in hours
      const hours = Math.floor(duration / 3600);
      const minutes = Math.floor((duration % 3600) / 60);
      return `${hours} hour${hours > 1 ? "s" : ""} ${minutes} minute${
        minutes > 1 ? "s" : ""
      }`;
    } else if (duration >= 60) {
      // Display in minutes
      const minutes = Math.floor(duration / 60);
      return `${minutes} minute${minutes > 1 ? "s" : ""}`;
    } else {
      // Display in seconds
      return `${duration} second${duration > 1 ? "s" : ""}`;
    }
  }

  const [flagFullScreen, setFlagFullScreen] = useState(false);
  const handleVideoDoubleClick = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    // define a custom handler function
    // for the contextmenu event
    const handleContextMenu = (e) => {
      // prevent the right-click menu from appearing
      e.preventDefault();
    };

    // attach the event listener to
    // the document object
    document.addEventListener("contextmenu", handleContextMenu);

    // clean up the event listener when
    // the component unmounts
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    if (!document.fullscreenElement && flagFullScreen) {
      playerRef.current.pause();
      navigate("/");
    } else {
      setFlagFullScreen(true);
    }
  }, [document.fullscreenElement]);
  return (
    <>
      {/* <Navbar/> */}
      {/* <Prompt/> */}
      {/* <Prompt when={shouldBlockNavigation} message='hello'></Prompt> */}
      <div ref={ref} tabIndex={-1} onKeyDown={key1}>
        {/* <h2>hello world</h2> */}
        <div class="section section-padding" style={{ paddingTop: "5%" }}>
          <div
            class="container"
            // style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              class="row"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className={`left-side-div ${isOpen ? "open" : "closed"}`}>
                  <button className="arrow-button" onClick={toggleOpen}>
                    {isOpen ? (
                      <>
                        <i class="fa-solid fa-caret-left"></i>
                      </>
                    ) : (
                      <>
                        <i class="fa-solid fa-caret-right"></i>
                      </>
                    )}
                  </button>
                  {/* <SearchBar /> */}

                  {/* <h1 style={{textAlign:'right'}}>المسودات</h1> */}
                  <div className="p-2">
                    {/* <label> <i class="fa-solid fa-magnifying-glass"></i></label> */}
                    {/* <input className="form-control" placeholder="search" value={keyword} onChange={(e) => setKeyword(e.target.value)} /> */}
                  </div>
                  {allLessons.map((p, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-12">
                        <div className="content">
                          <div
                            className="row"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              className="col-md-2"
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                fontFamily: "Poppins",
                                fontSize: "18px",
                              }}
                            >
                              <i
                                class="fa-brands fa-youtube"
                                style={{ color: "#ffc600" }}
                              ></i>
                              {p.name}
                            </div>
                            <div
                              className="col-md-8"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                {formatDuration(p.duration)}
                              </span>
                              <button
                                className="btn"
                                style={{
                                  backgroundColor: "#ffc600",
                                  color: "#fff",
                                }}
                                onClick={() => EachLesson(p.real_id)}
                              >
                                watch
                              </button>
                              {p.duration == p.viewed ? (
                                <>
                                  <i class="fa-solid fa-check"></i>
                                </>
                              ) : (
                                <>
                                  <i class="fa-solid fa-xmark"></i>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="row p-3">
                            <div
                              class="progress"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                class="progress-bar"
                                role="progressbar"
                                style={{ width: `${p.progress}%` }}
                                aria-valuenow={`${p.progress}`}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              >
                                {p.progress} %
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-8">
                <div
                  class="progress"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={`${progress}`}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
              </div>

              <div
                className="col-md-10 p-1"
                style={{
                  minHeight: "1px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div className="container">
                  <div className="row">
                   <h2
                    class="title p-3" 
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                      color: "rgb(33, 37, 41)",
                      fontSize: "21px",
                      fontWeight: "700",
                      fontFamily: "Poppins",
                    }}
                  >
                    {showLessons.name}
                  </h2>
                  </div>
                 <div className="row">
                 
                    <div
                      style={{
                       
                        margin: "auto",
                        display: "flex !important",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        id="video-player-container"
                        className="myVideo"
                        style={{
                          positon: "relative",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <animated.div style={springProps}>
                          {showMessage && (
                            <div
                              style={{
                                width: "20%",
                                height: "20%",
                                position: "absolute",
                                opacity: "0.6",
                                color: "red",
                                fontSize: "15px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: "999099999",
                              }}
                            >
                              {text}
                            </div>
                          )}
                        </animated.div>

                        {/* onClick={onButtonClickHandler} */}

                        <Player
                          ref={playerRef}
                          autoPlay={false}
                          src={showLessons.video}
                          width="100%"
                          height="100%"
                          controlBarClassName="my-custom-class"
                          playbackRate={0.5}
                       
                          onPlay={() => {
                            const currentTime =
                              playerRef.current.getState().player.currentTime;
                            sessionStorage.setItem("progress", currentTime);
                            onButtonClickHandler();
                          }}
                          onPause={() => {
                            const currentTime =
                              playerRef.current.getState().player.currentTime;
                            sessionStorage.setItem("progress", currentTime);
                          }}
                          onEnded={async () => {
                            if (showLessons.viewed != showLessons.duration) {
                              const currentTime =
                                playerRef.current.getState().player.currentTime;

                              let response = await axios.post(
                                "https://maps-medics-be.onrender.com/read_lesson/" +
                                  real_id +
                                  "/" +
                                  sessionStorage.getItem("user_id"),
                                { duration: currentTime }
                              );
                            }
                          }}
                        // Disable double-click fullscreen

                          disablePictureInPicture
                          disableDoubleClickFullscreen 
                        >
                          <BigPlayButton position="center" />

                          <ControlBar autoHide={false} className="my-class" >
                            <ReplayControl seconds={10} order={2} />
                            <ForwardControl seconds={10} order={3} />
                            <PlaybackRateMenuButton
                              rates={[2,1.75, 1.5,1.25, 1, 0.75, 0.5]}
                            />
                             <button
            className="video-react-fullscreen-control"
            onClick={handleFullscreenButtonClick}
          >
            {/* Custom fullscreen button */}
          </button>
                          </ControlBar>
            
                        </Player>
                        <style>
    {`
      .video-react .video-react-control-bar .video-react-fullscreen-control {
        display: none !important;
      }
    `}
  </style>
                      </div>
                    </div>
                    {/* <h3  style={{textDecoration:'none', cursor:'pointer' , color:'rgb(33, 37, 41)', fontSize:'21px', fontWeight:'700', fontFamily:'Poppins' }} >{p.name}</h3> */}
                 
                   
                    <div className="row p-3">
                      <div className="col-md-12"> <p
                      style={{
                        textDecoration: "none",
                        marginTop: "0.5rem",
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "rgb(32, 33, 34)",
                        fontFamily: "Poppins",
                      }}
                    >
                      {showLessons.description}
                    </p></div>
                      <div className="col-md-12 p-2">
                        <a href={showLessons.pdf1} >
                          <i
                            class="fa-regular fa-file-pdf fs-1"
                            style={{ color: "#ffc600" }}
                          ></i>
                        </a>
                      </div>{" "}
                      <div className="col-md-12 p-2">
                        <a href={showLessons.pdf2} >
                          <i
                            class="fa-regular fa-file-pdf fs-1"
                            style={{ color: "#ffc600" }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  
                 </div>
                
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </>
  );
};

export default CourseList;
